import React from "react";
import { AccordionPanel, IAccordionPanelProps } from "../../../components/panels/AccordionPanel";

export type GetAccordionPanelProps = IAccordionPanelProps & { id: string };

export const getAccordionPanel = (props: GetAccordionPanelProps) => (
  <AccordionPanel
    key={props.id}
    accordion={props.accordion}
    accordionSecondary={props.accordionSecondary}
    backgroundColour={props.backgroundColour}
    title={props.title}
    titleSecondary={props.titleSecondary}
    content={props.content}
    callToActions={props.callToActions}
    textAlign={props.textAlign}
    headingType={props.headingType}
    headerAnchor={props.headerAnchor}
    betterV2={props.betterV2}
    simple={props.simple}
    variant={props.variant}
    firstTabVariant={props.firstTabVariant}
    secondTabVariant={props.secondTabVariant}
    accordionTitle={props.accordionTitle}
    accordionTitleSecondary={props.accordionTitleSecondary}
    snapScroll={props.snapScroll}
  />
);
